import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import useStyles from './myServicesStyles';
import EirButton from '../../../theme/EirButton';
import ESIMActivationModal from '../sim-replacement/ESIMActivationModal';
import { useHistory } from 'react-router-dom';
import { useWindowDimension } from '../../../hooks/windowDimensions';

const ESIMActivationTile = ({ services }) => {
    const classes = useStyles();
    const theme = useTheme();
    const [showActivationModal, setshowActivationModal] = useState(false);
    const [serviceId, setServiceId] = useState(null);
    const history = useHistory();
    const [width, height] = useWindowDimension();
    const [modalKey, setModalKey] = useState(0);

    const handleActivate = () => {
        if (services.length === 1) {
            setModalKey(prev => prev + 1);
            setshowActivationModal(true);
        } else if (services.length > 1) {
            history.push('/account/manage-sim');
        }
    };
    return (
        <>
            <Grid container className={classes.bannerTile}>
                <Grid item xs={12}>
                    <Box className={classes.bannerWrapper}>
                        <Typography variant='body2' className={classes.bannerText}>
                            Complete your eSIM installation now.
                        </Typography>
                        <EirButton
                            variants='primaryButtonSmall'
                            style={{
                                padding: width < 600 ? '0.5rem 1.793rem' : '0.5rem 1.375rem',
                                whiteSpace: 'nowrap',
                            }}
                            onClick={handleActivate}
                            aria-label='Activate eSIM and view setup instructions'
                            role='button'
                        >
                            Activate eSIM
                        </EirButton>
                    </Box>
                </Grid>
            </Grid>
            {showActivationModal && (
                <ESIMActivationModal
                    key={modalKey}
                    serviceId={services[0].id}
                    openActivationModal={showActivationModal}
                    setOpenActivationModal={setshowActivationModal}
                    header={'Activate your  eSIM'}
                />
            )}
        </>
    );
};
export default ESIMActivationTile;
